import { ref, watch, computed, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import { useRouter } from '@/@core/utils/utils'

export default function useEventsHourly() {
  // Use toast
  const toast = useToast()
  const route = useRouter()
  const refUserListTable = ref(null)

  // Table Columns
  const tableColumns = [
    { key: 'date', label: 'Event Tarihi', sortable: true },
    { key: 'time', label: 'Event Saati', sortable: true },
    { key: 'total_visits', label: 'Event Sayısı', sortable: true, tdClass: "text-center", thClass: "text-center" },
  ]

  const perPage = ref(10)
  const totalEvents = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('recorded_at')
  const isSortDirDesc = ref(true)
  const eventHourlyData = ref([])
  const additionalParams = ref({})

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEvents.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
    fetchEvents();
  }

  watch([currentPage, perPage, searchQuery, additionalParams], () => {
    refetchData()
  })

  onMounted(() => {
    if(!additionalParams.value){ //eğer filtre olacaksa mounted da data çağırılmasın.
      fetchEvents();
    }
  });

  const fetchEvents = () => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      ...additionalParams.value
    }

    axiosIns
      .get('/eventDetail', { params })
      .then(response => {
        const { EventHourly, total } = response.data.data
        totalEvents.value = total;
        eventHourlyData.value = EventHourly;
      })
      .catch(error => {
        if (!error.response || error.response.status !== 401) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching hourly events',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  return {
    fetchEvents,
    tableColumns,
    eventHourlyData,
    additionalParams,
    perPage,
    currentPage,
    totalEvents,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    refetchData,
  }
}
